const integer = () => (value) =>
  value && !Number.isInteger(Number(value))
    ? 'Must be an integer'
    : undefined

export default integer
